import { ErrorHandlerService } from './../../services/shared/error-handler.service';
import { HelpdeskService } from './../../services/helpdesk/helpdesk.service';
import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { UserServiceService } from '../../services/user-service/user-service.service';
import { LeadsService } from '../../services/lead-service/lead-service.service';

@Component({
  selector: 'app-lead-actions',
  templateUrl: './lead-actions.component.html',
  styleUrls: ['./lead-actions.component.css']
})
export class LeadActionsComponent implements OnInit {
  tabs: any = [
    {
      name: "Meeting Types",
      active: true,
    },
    {
      name: "Event Statuses",
      active: false,
    },
    {
      name: "Call Types",
      active: false,
    },
    {
      name: "Message Sources",
      active: false,
    },
    {
      name: "Feedback Statuses",
      active: false,
    },
  ];

  active_tab: any = this.tabs[0].name;

  name: any = "";
  color: any = "";
  bg_color: any = "";
  names: any;
  isEdit: boolean = false;
  nameObj = {};
  meetingTypes: any;
  eventStatuses: any;
  callTypes: any;
  messageSources: any;
  feedbackStatuses: any;
  leadStatuses: any;
  action_type: any;
  lead_status: any;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private userService: UserServiceService,
    private leadsService: LeadsService,
    private helpdeskService: HelpdeskService,
    private errorService: ErrorHandlerService,
  ) {}

  ngOnInit() {
    this.getAllLeadsStatus();
    this.getMeetingTypes();
    this.getEventStatuses();
    this.getCallTypes();
    this.getMessageSources();
    this.getFeedbackStatuses();
  }

  getAllLeadsStatus() {
    this.leadsService.getAllLeadsStatus().subscribe(
      (res: any) => {
        this.leadStatuses = res;
      },
      (err) => {
        this.errorService.handleErorr(err);
      }
    );
  }

  getMeetingTypes() {
    this.helpdeskService.getMeetingTypes().subscribe((res: any) => {
      this.meetingTypes = res;
      this.setTableView(this.active_tab);
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  getEventStatuses(setView: boolean = false) {
    this.helpdeskService.getEventStatuses().subscribe((res: any) => {
      this.eventStatuses = res;
      if(setView) {
        this.setTableView(this.active_tab);
      }
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  getCallTypes(setView: boolean = false) {
    this.helpdeskService.getCallTypes().subscribe((res: any) => {
      this.callTypes = res;
      if(setView) {
        this.setTableView(this.active_tab);
      }
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  getMessageSources(setView: boolean = false) {
    this.helpdeskService.getMessageSources().subscribe((res: any) => {
      this.messageSources = res;
      if(setView) {
        this.setTableView(this.active_tab);
      }
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  getFeedbackStatuses(setView: boolean = false) {
    this.helpdeskService.getFeedbackStatuses().subscribe((res: any) => {
      res.forEach((status) => {
        status.action_type ? status.action_type : status.action_type = [];
        if (typeof status.action_type === 'string') {
          status.action_type = JSON.parse(status.action_type);
        }
      })
      this.feedbackStatuses = res;
      if(setView) {
        this.setTableView(this.active_tab);
      }
    }, err => {
      this.errorService.handleErorr(err);
    });
  }


  setActiveTab(tab, index) {
    this.tabs.forEach((group) => {
      group.active = false;
    });
    this.name = "";
    this.names = null;
    this.setTableView(tab.name);
    this.active_tab = tab.name;
    this.tabs[index].active = true;
  }

  setTableView(tabName) {
    switch (tabName) {
      case "Meeting Types":
        this.names = this.meetingTypes;
        break;
      case "Event Statuses":
        this.names = this.eventStatuses;
        break;
      case "Call Types":
        this.names = this.callTypes;
        break;
      case "Message Sources":
        this.names = this.messageSources;
        break;
      case "Feedback Statuses":
        this.names = this.feedbackStatuses;
        break;
      default:
        break;
    }
  }

  addName(tab) {
    switch (tab.name) {
      case "Meeting Types":
        this.addMeetingType();
        break;
      case "Event Statuses":
        this.addEventStatus();
        break;
      case "Call Types":
        this.addCallType();
        break;
      case "Message Sources":
        this.addMessageSource();
        break;
      case "Feedback Statuses":
        this.addFeedbackStatus();
        break;
      default:
        break;
    }
  }

  addMeetingType() {
    let payload = {
      name: this.name
    }
    this.helpdeskService.addMeetingType(payload).subscribe((res: any) => {
      swal('Success', 'Saved Meeting Type', 'success');
      this.getMeetingTypes();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  addEventStatus() {
    let payload = {
      name: this.name,
      lead_status: this.lead_status
    }
    this.helpdeskService.addEventStatus(payload).subscribe((res: any) => {
      swal('Success', 'Saved Event Status', 'success');
      this.getEventStatuses();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  addCallType() {
    let payload = {
      name: this.name,
      lead_status: this.lead_status
    }
    this.helpdeskService.addCallType(payload).subscribe((res: any) => {
      swal('Success', 'Saved Call Type', 'success');
      this.getCallTypes();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  addMessageSource() {
    let payload = {
      name: this.name,
      lead_status: this.lead_status
    }
    this.helpdeskService.addMessageSource(payload).subscribe((res: any) => {
      swal('Success', 'Saved Message Source', 'success');
      this.getMessageSources();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  addFeedbackStatus() {
    let payload = {
      name: this.name,
      color: this.color,
      bg_color: this.bg_color,
      action_type: this.action_type
    }
    this.helpdeskService.addFeedbackStatus(payload).subscribe((res: any) => {
      swal('Success', 'Saved Feedback Status', 'success');
      this.getFeedbackStatuses();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  deleteName(tab, id, index) {
    switch (tab.name) {
      case "Meeting Types":
        this.deleteMeetingTypes(id);
        break;
      case "Event Statuses":
        this.deleteEventStatuses(id);
        break;
      case "Call Types":
        this.deleteCallTypes(id);
        break;
      case "Message Sources":
        this.deleteMessageSources(id);
        break;
      case "Feedback Statuses":
        this.deleteFeedbackStatuses(id);
        break;
      default:
        break;
    }
  }

  deleteMeetingTypes(id) {
    this.helpdeskService.deleteMeetingType(id).subscribe((res: any) => {
      swal('Success', 'Deleted Meeting Type', 'success');
      this.getMeetingTypes();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  updateData(tab) {
    switch (tab) {
      case "Meeting Types":
        this.getMeetingTypes();
        break;
      case "Event Statuses":
        this.getEventStatuses(true);
        break;
      case "Call Types":
        this.getCallTypes(true);
        break;
      case "Message Sources":
        this.getMessageSources(true);
        break;
      case "Feedback Statuses":
        this.getFeedbackStatuses(true);
        break;
      default:
        break;
    }

  }

  activateName(tab, id) {
    switch (tab) {
      case "Meeting Types":
        this.activateLeadAction('meeting-types', id, tab);
        break;
      case "Event Statuses":
        this.activateLeadAction('event-statuses', id, tab);
        break;
      case "Call Types":
        this.activateLeadAction('call-types', id, tab);
        break;
      case "Message Sources":
        this.activateLeadAction('message-sources', id, tab);
        break;
      case "Feedback Statuses":
        this.activateLeadAction('feedback-statuses', id, tab);
        break;
      default:
        break;
    }
  }

  deactivateName(tab, id) {
    switch (tab) {
      case "Meeting Types":
        this.deactivateLeadAction('meeting-types', id, tab);
        break;
      case "Event Statuses":
        this.deactivateLeadAction('event-statuses', id, tab);
        break;
      case "Call Types":
        this.deactivateLeadAction('call-types', id, tab);
        break;
      case "Message Sources":
        this.deactivateLeadAction('message-sources', id, tab);
        break;
      case "Feedback Statuses":
        this.deactivateLeadAction('feedback-statuses', id, tab);
        break;
      default:
        break;
    }
  }

  activateLeadAction(action_type: string, id: number, tabName: string) {
    this.slimLoadingBarService.start();
    this.helpdeskService.activateLeadAction(action_type, id).subscribe((res: any) => {
      swal('Success', res.message, 'success');
      this.updateData(tabName);
      this.slimLoadingBarService.complete();
    }, err => {
      this.errorService.handleErorr(err);
      this.slimLoadingBarService.reset();
    });
  }

  deactivateLeadAction(action_type: string, id: number, tabName: string) {
    this.slimLoadingBarService.start();
    this.helpdeskService.deactivateLeadAction(action_type, id).subscribe((res: any) => {
      swal('Success', 'Deactivated Meeting Type', 'success');
      this.updateData(tabName);
      this.slimLoadingBarService.complete();
    }, err => {
      this.errorService.handleErorr(err);
      this.slimLoadingBarService.reset();
    });
  }

  deleteEventStatuses(id) {
    this.helpdeskService.deleteEventStatus(id).subscribe((res: any) => {
      swal('Success', 'Deleted Event Status', 'success');
      this.getEventStatuses();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  deleteCallTypes(id) {
    this.helpdeskService.deleteCallType(id).subscribe((res: any) => {
      swal('Success', 'Deleted Call Type', 'success');
      this.getCallTypes();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  deleteMessageSources(id) {
    this.helpdeskService.deleteMessageSource(id).subscribe((res: any) => {
      swal('Success', 'Deleted Message Source', 'success');
      this.getMessageSources();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  deleteFeedbackStatuses(id) {
    this.helpdeskService.deleteFeedbackStatus(id).subscribe((res: any) => {
      swal('Success', 'Deleted Feedback Status', 'success');
      this.getFeedbackStatuses();
    }, err => {
      this.errorService.handleErorr(err);
    });
  }

  editName(name){
    this.isEdit = true;
    this.nameObj = name;
    this.name = name.name
    this.color = name.color
    this.bg_color = name.bg_color
  }

  cancelEdit(){
    this.name = '';
    this.nameObj = {};
    this.isEdit = false;
  }

  saveEditName(tab){
    switch (tab.name) {
      case "Meeting Types":
        this.editMeetingType(this.nameObj['id']);
        break;
      case "Event Statuses":
        this.editEventStatus(this.nameObj['id']);
        break;
      case "Call Types":
        this.editCallType(this.nameObj['id']);
        break;
      case "Message Sources":
        this.editMessageSource(this.nameObj['id']);
        break;
      case "Feedback Statuses":
        this.editFeedbackStatus(this.nameObj['id']);
        break;
      default:
        break;
    }
  }

  editMeetingType(id) {
    let payload = {
      name: this.name
    };
    this.slimLoadingBarService.start();
    this.helpdeskService.editMeetingType(id, payload)
      .subscribe((res: any) => {
        this.name = '';
        this.getMeetingTypes();
        swal('Success', 'Saved Meeting Type', 'success');
        this.slimLoadingBarService.complete();
        this.isEdit = false;
      }, err => {
        this.errorService.handleErorr(err);
        this.slimLoadingBarService.reset();
      });
  }

  editEventStatus(id) {
    let payload = {
      name: this.name,
      lead_status: this.lead_status
    };
    this.slimLoadingBarService.start();
    this.helpdeskService.editEventStatus(id, payload)
      .subscribe((res: any) => {
        this.name = '';
        this.lead_status = null;
        this.getEventStatuses();
        swal('Success', 'Saved Event Status', 'success');
        this.slimLoadingBarService.complete();
        this.isEdit = false;
      }, err => {
        this.errorService.handleErorr(err);
        this.slimLoadingBarService.reset();
      });
  }

  editCallType(id) {
    let payload = {
      name: this.name,
      lead_status: this.lead_status
    };
    this.slimLoadingBarService.start();
    this.helpdeskService.editCallType(id, payload)
      .subscribe((res: any) => {
        this.name = '';
        this.lead_status = null;
        this.getCallTypes();
        swal('Success', 'Saved Call Type', 'success');
        this.slimLoadingBarService.complete();
        this.isEdit = false;
      }, err => {
        this.errorService.handleErorr(err);
        this.slimLoadingBarService.reset();
      });
  }

  editMessageSource(id) {
    let payload = {
      name: this.name,
      lead_status: this.lead_status
    };
    this.slimLoadingBarService.start();
    this.helpdeskService.editMessageSource(id, payload)
      .subscribe((res: any) => {
        this.name = '';
        this.lead_status = null;
        this.getMessageSources();
        swal('Success', 'Saved Message Source', 'success');
        this.slimLoadingBarService.complete();
        this.isEdit = false;
      }, err => {
        this.errorService.handleErorr(err);
        this.slimLoadingBarService.reset();
      });
  }

  editFeedbackStatus(id) {
    let payload = {
      name: this.name,
      color: this.color,
      bg_color: this.bg_color,
      action_type: this.action_type
    };
    this.slimLoadingBarService.start();
    this.helpdeskService.editFeedbackStatus(id, payload)
      .subscribe((res: any) => {
        this.name = '';
        this.color = '';
        this.bg_color = '';
        this.action_type = null;
        this.getFeedbackStatuses();
        swal('Success', 'Saved Feedback Status', 'success');
        this.slimLoadingBarService.complete();
        this.isEdit = false;
      }, err => {
        this.errorService.handleErorr(err);
        this.slimLoadingBarService.reset();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/lead-actions/lead-actions.component.ts